import { isFunction } from '@utils/type/checker';

let requestIdleCallback: ReturnType<typeof getRequestIdleCallback>;

function getRequestIdleCallback() {
    return isFunction(window.requestIdleCallback) ? window.requestIdleCallback : window.setTimeout;
}

export function onNextIdle<T = void>(...args: unknown[]): Promise<T> {
    if (!requestIdleCallback) {
        requestIdleCallback = getRequestIdleCallback();
    }

    return new Promise((resolve) => {
        // @ts-expect-error: spread arguments
        requestIdleCallback(() => resolve(...args));
    });
}